import type { ReactNode } from 'react'

import { Icon } from '../../components/Icon'

/** Spec §C.3: the booking's steps, in order. */
const STEPS = ['Start', 'Service', 'Trip', 'Details', 'Pay', 'Done'] as const

/**
 * Where the person is in the booking. Each step is named in text; the
 * current one carries `aria-current="step"` and is bold, a finished one has a
 * tick and says "done", so nothing rests on colour alone.
 */
export function ProgressBar({ current }: { current: number }): ReactNode {
  return (
    <nav aria-label="Booking progress">
      <ol className="flex gap-1">
        {STEPS.map((label, i) => {
          const done = i < current
          const here = i === current
          return (
            <li
              key={label}
              aria-current={here ? 'step' : undefined}
              className="flex min-w-0 flex-1 flex-col gap-1"
            >
              <span
                aria-hidden="true"
                className={`h-1 rounded-full ${
                  done || here ? 'bg-accent' : 'bg-line-2'
                }`}
              />
              <span
                className={`flex items-center gap-0.5 truncate text-[10.5px] ${
                  here
                    ? 'font-semibold text-ink-1'
                    : done
                      ? 'text-ink-2'
                      : 'text-ink-3'
                }`}
              >
                {done && <Icon name="check" size={10} />}
                {label}
                {done && <span className="sr-only"> (done)</span>}
              </span>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
